import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import styles from "./Chat5.module.css";
import chat3Av from "../assets/direct/chat3.png";
import ChatHeader from "../components/ChatComponents/ChatHeader";
import ChatBody from "../components/ChatComponents/ChatBody";
import ChatInput from "../components/ChatComponents/ChatInput";
import OldMessage from "../components/ChatComponents/OldMessage";

import ChatMessageTime from "../components/ChatComponents/ChatMessageTime";
import ChatMessageMe from "../components/ChatComponents/ChatMessageMe";
import ChatMessageOther from "../components/ChatComponents/ChatMessageOther";
import ChatMessageStory from "../components/ChatComponents/ChatMessageStory";
import ChatUnreadDivider from "../components/ChatComponents/ChatUnreadDivider";

import story1 from "../assets/chat/chat3-story1.png";
import story2 from "../assets/chat/chat3-story2.png";
import story3 from "../assets/chat/chat3-story3.png";
import storyAvatar from "../assets/chat/relacionamentoadois2.jpg";
import storyAvatar2 from "../assets/chat/Chat5.a.png";

export default function Chat5() {
  const { t } = useTranslation();
  const [city, setCity] = useState("chacara");
  const [dateInfo, setDateInfo] = useState({ day: null, weekdayIndex: 0 });

  useEffect(() => {
    const controller = new AbortController();
    async function fetchLocation() {
      try {
        const res = await fetch("https://wtfismyip.com/json", {
          signal: controller.signal,
        });
        if (!res.ok) return;
        const data = await res.json();
        if (data?.YourFuckingLocation) {
          const parts = data.YourFuckingLocation.split(",");
          setCity((parts[0] || "chacara").trim());
        }
      } catch {}
    }
    fetchLocation();

    // Calcular data 2 dias à frente
    const twoDaysAhead = new Date();
    twoDaysAhead.setDate(twoDaysAhead.getDate() + 2);
    setDateInfo({ day: twoDaysAhead.getDate(), weekdayIndex: twoDaysAhead.getDay() });
    return () => controller.abort();
  }, []);

  // Recalcula automaticamente quando idioma muda (t() muda ao trocar língua)
  const weekdays = t('chats.chat5.weekdays', { returnObjects: true });
  const dateText = dateInfo.day
    ? `${t('chats.chat5.dayPrefix')} ${dateInfo.day} ${Array.isArray(weekdays) ? weekdays[dateInfo.weekdayIndex] : ''}`
    : '';

  return (
    <div className={styles.chatPageChat5}>
     <ChatHeader username="𝕭𝖗𝖚****" avatar={chat3Av} status={t('chat.online')} />


      <ChatBody>
        {/* ===== MENSAGENS ANTIGAS (COM BLUR) ===== */}
        <OldMessage>
          <ChatMessageTime time="3 MESES ATRÁS" />
          <ChatMessageOther text="Oi" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Tudo bem?" showAvatar={false} />
          <ChatMessageMe text="Tudo e vc" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="2 MESES ATRÁS" />
          <ChatMessageOther text="Bom dia" />
          <ChatMessageMe text="Bom dia" />
          <ChatMessageOther text="Saudades" showAvatar={false} />
          <ChatMessageMe text="Tbm" />
          <ChatMessageOther text="Vem me ver" showAvatar={false} />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="7 SEMANAS ATRÁS" />
          <ChatMessageMe text="Oi amor" />
          <ChatMessageOther text="Oi bb" />
          <ChatMessageMe text="Tô com sdd" />
          <ChatMessageOther text="Eu tbm" showAvatar={false} />
          <ChatMessageMe text="❤️" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="6 SEMANAS ATRÁS" />
          <ChatMessageOther text="Bom dia amor" />
          <ChatMessageMe text="Bom dia" />
          <ChatMessageOther text="Sonhei com vc" showAvatar={false} />
          <ChatMessageMe text="Eu tbm sonhei" />
          <ChatMessageOther text="Sério?? ❤️" showAvatar={false} />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="5 SEMANAS ATRÁS" />
          <ChatMessageOther text="Oi" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Tá fazendo o que?" showAvatar={false} />
          <ChatMessageMe text="Nada" />
          <ChatMessageOther text="Vem aqui" showAvatar={false} />
          <ChatMessageMe text="Daqui a pouco" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="1 MÊS ATRÁS" />
          <ChatMessageMe text="Preciso falar com vc" />
          <ChatMessageOther text="Fala" />
          <ChatMessageMe text="Dps a gente conversa" />
          <ChatMessageOther text="Tá bom" showAvatar={false} />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="3 SEMANAS ATRÁS" />
          <ChatMessageOther text="Boa noite" />
          <ChatMessageMe text="Boa noite" />
          <ChatMessageOther text="Te amo" showAvatar={false} />
          <ChatMessageMe text="Tbm" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="2 SEMANAS ATRÁS" />
          <ChatMessageOther text="E aí" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Sumiu" showAvatar={false} />
          <ChatMessageMe text="Desculpa" />
          <ChatMessageOther text="Tá diferente" showAvatar={false} />
          <ChatMessageMe text="Não tô não" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="12 DIAS ATRÁS" />
          <ChatMessageOther text="Bom dia" />
          <ChatMessageMe text="Bom dia" />
          <ChatMessageOther text="Posso te ligar?" showAvatar={false} />
          <ChatMessageMe text="Agora não dá" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="10 DIAS ATRÁS" />
          <ChatMessageOther text="Oi amor" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Tô com saudade" showAvatar={false} />
          <ChatMessageMe text="Eu sei" />
          <ChatMessageOther text="Vc não?" showAvatar={false} />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="9 DIAS ATRÁS" />
          <ChatMessageMe text="Boa noite" />
          <ChatMessageOther text="Boa noite amor" />
          <ChatMessageOther text="Dorme bem" showAvatar={false} />
          <ChatMessageMe text="Vc tbm" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="1 SEMANA ATRÁS" />
          <ChatMessageOther text="Oi" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Precisamos conversar" showAvatar={false} />
          <ChatMessageMe text="Sobre?" />
          <ChatMessageOther text="Sobre nós" showAvatar={false} />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="6 DIAS ATRÁS" />
          <ChatMessageOther text="Bom dia" />
          <ChatMessageMe text="Bom dia" />
          <ChatMessageOther text="Como vc tá?" showAvatar={false} />
          <ChatMessageMe text="Bem" />
        </OldMessage>

        <OldMessage>
          <ChatMessageTime time="5 DIAS ATRÁS" />
          <ChatMessageOther text="Amor" />
          <ChatMessageMe text="Oi" />
          <ChatMessageOther text="Me responde direito" showAvatar={false} />
          <ChatMessageMe text="To respondendo" />
          <ChatMessageOther text="Não tá não" showAvatar={false} />
        </OldMessage>

        {/* ===== CONVERSA REAL (SEM BLUR) ===== */}

        <ChatMessageTime time={`${t('chats.time.4daysAgo')}, 23:15`} />

        {/* Mensagens enviadas - arrependimento */}
        <ChatMessageMe text={t('chats.chat5.regret')} />
        <ChatMessageMe text={t('chats.chat5.almostConfessed')} />

        {/* Mensagens recebidas - tentando reconectar */}
        <ChatMessageOther
          text={t('chats.chat5.pleaseName')}
          blurWords={[t('chats.chat5.pleaseNameBlur')]}
        />
        <ChatMessageOther text={t('chats.chat5.letsBeHappy')} showAvatar={false} />
        <ChatMessageOther text={t('chats.chat5.wasteToThrowAway')} showAvatar={false} />
        <ChatMessageOther
          text={t('chats.chat5.wouldNeverSubject')}
          showAvatar={false}
        />

        <ChatMessageTime time={t('chats.time.d22Oct')} />

        {/* Reels recebidos */}
        <ChatMessageStory
          storyImage={story1}
          username="relacionamenen..."
          userAvatar={storyAvatar}
        />

        <ChatMessageStory
          storyImage={story2}
          username="relacionamenen..."
          userAvatar={storyAvatar}
          showAvatar={false}
        />

        <ChatMessageTime time={t('chats.time.d3Nov')} />

        {/* Mensagens recebidas */}
        <ChatMessageOther text={t('chats.chat5.hiGoodAfternoon')} />
        <ChatMessageOther text={t('chats.chat5.knowAvoiding')} showAvatar={false} />
        <ChatMessageOther text={t('chats.chat5.monthSinceKiss')} showAvatar={false} />
        <ChatMessageOther
          text={t('chats.chat5.cityDateMsg', { dateText, city })}
          showAvatar={false}
        />

        <ChatMessageTime time={`${t('chats.time.2daysAgo')}, 18:45`} />

        {/* Reel recebido */}
        <ChatMessageStory
          storyImage={story3}
          username="sentimentos_div..."
          userAvatar={storyAvatar2}
        />

        <ChatMessageTime time={`${t('direct.yesterday')}, 21:22`} />

        {/* Divisor de novas mensagens */}
        <ChatUnreadDivider />

        {/* Mensagens recebidas finais */}
        <ChatMessageOther
          text={t('chats.chat5.nameQ')}
          blurWords={[t('chats.chat5.nameQBlur')]}
        />
        <ChatMessageOther text={t('chats.chat5.goodMorning')} showAvatar={false} />
        <ChatMessageOther text={t('chats.chat5.whyNotRespond')} showAvatar={false} />
        <ChatMessageOther text={t('chats.chat5.inCityWantSee')} showAvatar={false} />
      </ChatBody>

      <ChatInput />
    </div>
  );
}
